export class teacherSubstituteAdd {
  static readonly type = '[teacherSubstituteAdd] add';
  constructor(public teacherSubstituteData: any) {}
}

export class teacherSubstituteRemove {
  static readonly type = '[teacherSubstituteRemove] remove';
}
